import { useEffect, useRef } from "react";

export function useBrowserNotification() {
  const permissionRef = useRef<NotificationPermission>("default");

  useEffect(() => {
    if ("Notification" in window) {
      permissionRef.current = Notification.permission;
    }
  }, []);

  const requestPermission = async () => {
    if (!("Notification" in window)) return false;
    if (Notification.permission === "granted") return true;
    const result = await Notification.requestPermission();
    permissionRef.current = result;
    return result === "granted";
  };

  const sendNotification = (title: string, body: string, onClick?: () => void) => {
    if (!("Notification" in window)) return;
    if (Notification.permission !== "granted") return;

    // Only send if tab is not focused
    if (document.hasFocus()) return;

    const notification = new Notification(title, {
      body,
      icon: "/logo.svg",
      badge: "/logo.svg",
    });

    if (onClick) {
      notification.onclick = () => {
        window.focus();
        onClick();
        notification.close();
      };
    }

    // Auto close after 10 seconds
    setTimeout(() => notification.close(), 10_000);
  };

  return { requestPermission, sendNotification };
}
